<template>
  <b-modal :title="`Add Account`" v-model="visible" @ok="save" @cancel="hide" ok-title="Save" :ok-disabled="!canSave || saving">
    <b-row>
      <b-col cols="8">
        <b-form-group>
          <label for="name">Name</label>
          <b-form-input type="text" id="name" placeholder="i.e. VirtuPhone LLC" v-model="name" autocomplete="off"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group>
          <label for="prefix">Prefix</label>
          <b-form-input type="text" id="prefix" placeholder="i.e. virtuphone" v-model="prefix" autocomplete="off"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="8">
        <b-form-group>
          <label for="type">Type</label>
          <b-select id="type" :options="typeOptions" v-model="type"></b-select>
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    canSave () {
      if (this.name.length > 0 && this.prefix.length > 0) {
        return true
      }
      return false
    },
    ...mapGetters({
      account: 'global/account'
    }),
  },
  data () {
    return {
      visible: false,
      saving: false,
      name: '',
      prefix: '',
      type: null,
      typeOptions: [
        { value: 'residential', text: 'Residential' },
        { value: 'business', text: 'Business' }
      ]
    }
  },
  methods: {
    async save () {
      const accountData = {
        name: this.name,
        type: this.type,
        prefix: this.prefix
      }
      const { data } = await this.$axios.post(`/v1/accounts`, accountData)
      this.$emit('add', data)
    },
    show () {
      this.visible = true
      this.name = ''
      this.prefix = ''
      this.lastAutoPrefix = ''
    },
    hide () {
      this.visible = false
    }
  },
  mounted () {
    this.$bus.$on('modal:addAccount', () => {
      this.show();
    })
  },
  beforeDestroy () {
    this.$bus.$off('modal:addAccount')
  },
  watch: {
    name (value) {
      const autoPrefix = value.replaceAll(' ', '').toLowerCase()
      if (this.lastAutoPrefix === this.prefix) {
        this.prefix = autoPrefix
      }
      this.lastAutoPrefix = autoPrefix
    }
  }
}
</script>
